import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as feather from 'feather-icons';
import { ParametreService } from '../../main-parametre/parametre.service';
import { CroudTvaComponent } from './croud-tva/croud-tva.component';
import { Tva, TvaService } from './tva.service';

@Component({
  selector: 'app-parametre-tva',
  templateUrl: './parametre-tva.component.html',
  styleUrls: ['./parametre-tva.component.scss'],
})
export class ParametreTvaComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('croudTva') croudTva!: CroudTvaComponent;

  stationId: number | null = null;
  clientId: number | null = null;
  tvaList: Tva[] = [];
  isLoading = false;
  error: string | null = null;

  private subscriptions = new Subscription();

  constructor(
    private tvaService: TvaService,
    private toastr: ToastrService,
    private router: Router,
    private parametreService: ParametreService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadUserData();
    this.subscriptions.add(
      this.parametreService.openModal$.subscribe(({ component, action, subType }) => {
        if (component === 'taxe-tva' && action === 'add' && (subType === 'tva' || !subType)) {
          this.croudTva?.openModal('ajouter');
        }
      })
    );
  }

  ngAfterViewInit(): void {
    this.replaceFeatherIcons();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  loadUserData(): void {
    const user = localStorage.getItem('currentUser');
    if (user) {
      try {
        const currentUser = JSON.parse(user);
        this.clientId = currentUser?.id ?? null;
        if (currentUser?.stations?.length > 0) {
          this.stationId = currentUser.stations[0].id;
          this.loadTvaList();
        } else {
          this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
          this.router.navigate(['/create-station']);
        }
      } catch {
        this.toastr.error('Erreur lors de la lecture des données utilisateur.', 'Erreur');
      }
    } else {
      this.toastr.error('Utilisateur non connecté.', 'Erreur');
      this.router.navigate(['/pages/authentication/login-v2']);
    }
  }

  loadTvaList(): void {
    if (this.stationId === null) {
      this.error = 'Aucune station disponible.';
      return;
    }
    this.isLoading = true;
    this.error = null;
    this.tvaService.getTvaList(this.stationId).subscribe({
      next: (response) => {
        if (response?.success) {
          this.tvaList = response.tvaListe || [];
          if (this.tvaList.length === 0) {
            this.error = null;
          }
        } else {
          this.tvaList = [];
          this.error = 'Aucune TVA trouvée.';
        }
        this.isLoading = false;
        this.cdr.detectChanges();
        this.replaceFeatherIcons();
      },
      error: (err) => {
        this.isLoading = false;
        this.tvaList = [];
        this.error = 'Erreur lors du chargement des TVA: ' + (err.message || 'Erreur inconnue');
        this.cdr.detectChanges();
      },
    });
  }

  patchTva(updatedTva: Tva): void {
    const index = this.tvaList.findIndex((t) => t.id === updatedTva.id);
    if (index !== -1) {
      this.tvaList[index] = { ...this.tvaList[index], ...updatedTva };
      this.tvaList = [...this.tvaList];
      this.cdr.detectChanges();
      this.replaceFeatherIcons();
    }
  }

  replaceFeatherIcons(): void {
    try {
      feather.replace();
    } catch {
      // feather-icons optionnel
    }
  }

  isCheckIcon(tva: Tva): boolean {
    return tva.statut;
  }

  isCrossIcon(tva: Tva): boolean {
    return !tva.statut;
  }

  getTvaValue(tva: Tva): string {
    return `${tva.type}${tva.valeur}${tva.restriction === 'Pourcentage' ? ' %' : ' %'}`;
  }

  editTva(tva: Tva): void {
    this.croudTva?.openModal('update', tva);
  }

  toggleTva(tva: Tva, event: Event): void {
    event.preventDefault();
    this.croudTva?.openModal('etat', tva, !tva.statut);
  }
}
